import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, InputNumber, DatePicker, Icon, notification } from "antd";
import axios from "axios";
import moment from "moment";
const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerAdicionarPlano = ({ id, visible, atualizarListagem, onClose, form }) => {
    const [registo, setRegisto] = useState({
        id: null,
        data_realizacao: moment(),
        nome: "",
        idade: null,
        ano_serie: "",
        turno: "",
        escola: "",
        professor_aee: "",
        historico_escolas: "",
        necessidades_educacionais: "",
        objetivos_cognitivos: "",
        objetivos_socioemocionais: "",
        estrategias_recursos: "",
        parcerias: "",
        cronograma_atendimentos: "",
        avaliacao_monitoramento: "",
        descricao: "",
        tecnicas_utilizadas: ""
    });
    const [dtInicio, setDtInicio] = useState(null);
    const [dtTermino, setDtTermino] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const intervaloCalendario = () => {
        axios({
            method: "get",
            url: "/api/aulas/intervalo-calendario-turma",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { dt_inicio, dt_termino } = response.data;

                setDtInicio(dt_inicio);
                setDtTermino(dt_termino);
            })
            .catch(() => {});
    };

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                if (id) alterarPlano(values);
                else adicionarPlano(values);
            }
        });
    };

    const carregarDetalhe = id => {
        axios({
            method: "get",
            url: "/api/atendimento/carregar-plano-atendimento",
            params: {
                id
            }
        })
            .then(response => {
                const dados = {
                    ...response.data,
                    data_realizacao: response.data.data_realizacao ? moment(response.data.data_realizacao) : null
                };
                setRegisto(dados);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro ao carregar os planos de atendimento.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const adicionarPlano = registo => {
        setIsLoading(true);

        let plano = {
            disciplinaId: localStorage.getItem("codigo_curso"),
            tipo: "plano_atendimento_especializado",
            dataRealizacao: registo.data_realizacao.format("YYYY-MM-DD"),
            nome: registo.nome,
            idade: registo.idade,
            anoSerie: registo.ano_serie,
            turno: registo.turno,
            escola: registo.escola,
            professorAee: registo.professor_aee,
            historicoEscolas: registo.historico_escolas,
            necessidadesEducacionais: registo.necessidades_educacionais,
            objetivosCognitivos: registo.objetivos_cognitivos,
            objetivosSocioemocionais: registo.objetivos_socioemocionais,
            estrategiasRecursos: registo.estrategias_recursos,
            parcerias: registo.parcerias,
            cronogramaAtendimentos: registo.cronograma_atendimentos,
            avaliacaoMonitoramento: registo.avaliacao_monitoramento
        };

        axios({
            method: "post",
            url: "/api/atendimento/adicionar-plano-atendimento",
            data: plano
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Plano de Atendimento criado com sucesso.");
                atualizarListagem();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro ao criar os planos de atendimento.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const alterarPlano = registo => {
        setIsLoading(true);

        let plano = {
            id: id,
            dataRealizacao: registo.data_realizacao.format("YYYY-MM-DD"),
            nome: registo.nome,
            idade: registo.idade,
            anoSerie: registo.ano_serie,
            turno: registo.turno,
            escola: registo.escola,
            professorAee: registo.professor_aee,
            historicoEscolas: registo.historico_escolas,
            necessidadesEducacionais: registo.necessidades_educacionais,
            objetivosCognitivos: registo.objetivos_cognitivos,
            objetivosSocioemocionais: registo.objetivos_socioemocionais,
            estrategiasRecursos: registo.estrategias_recursos,
            parcerias: registo.parcerias,
            cronogramaAtendimentos: registo.cronograma_atendimentos,
            avaliacaoMonitoramento: registo.avaliacao_monitoramento
        };

        axios({
            method: "put",
            url: "/api/atendimento/alterar-plano-atendimento",
            data: plano
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Plano de Atendimento altarado com sucesso.");
                atualizarListagem();
            })
            .catch(error => {
                openNotificationWithIcon("Ocorreu um erro ao alterar o Plano de Atendimento.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    nome: aluno?.nome || "",
                    ano_serie: turma?.nome || "",
                    idade: aluno?.idade ?? null,
                    professor_aee: turma?.professor || "",
                    escola: turma?.escola || "",
                    turno: turma?.turno || ""
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && id === null) {
            limparCampos();
        }
    };

    const limparCampos = () => {
        form.resetFields();
        setRegisto({
            id: null,
            data_realizacao: moment(),
            nome: "",
            idade: null,
            ano_serie: "",
            turno: "",
            escola: "",
            professor_aee: "",
            historico_escolas: "",
            necessidades_educacionais: "",
            objetivos_cognitivos: "",
            objetivos_socioemocionais: "",
            estrategias_recursos: "",
            parcerias: "",
            cronograma_atendimentos: "",
            avaliacao_monitoramento: ""
        });
    };

    useEffect(() => {
        if (visible && id) {
            carregarDetalhe(id);
        }

        if (visible && !id) {
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [id, visible]);

    const { getFieldDecorator } = form;

    return (
        <>
            <Drawer
                title={
                    <div>
                        <div style={{ fontWeight: "bold", fontSize: 16 }}>Cadastro de Plano de Atendimento</div>
                        <div style={{ fontSize: 12, color: "#888" }}>Preencha os dados para cadastrar um novo plano de atendimento.</div>
                    </div>
                }
                className="drawer-adicionar-evento drawer-add-cursos"
                width={720}
                onClose={handleClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-info">
                    <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                        <div className="bloco" style={{ marginBottom: 50 }}>
                            <Form.Item label="Data de Realização">
                                {getFieldDecorator("data_realizacao", {
                                    initialValue: registo.data_realizacao,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<DatePicker className="input-25" placeholder="Selecionar" format="DD-MM-YYYY" />)}
                            </Form.Item>
                        </div>
                        <div className="bloco" style={{ marginBottom: 50 }}>
                            <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                1. Identificação do Estudante
                            </h3>
                            <Form.Item label="Nome">
                                {getFieldDecorator("nome", {
                                    initialValue: registo.nome,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Idade">
                                {getFieldDecorator("idade", { initialValue: registo.idade })(<InputNumber />)}
                            </Form.Item>
                            <Form.Item label="Ano/Série">
                                {getFieldDecorator("ano_serie", { initialValue: registo.ano_serie })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Turno">{getFieldDecorator("turno", { initialValue: registo.turno })(<Input />)}</Form.Item>
                            <Form.Item label="Escola">{getFieldDecorator("escola", { initialValue: registo.escola })(<Input />)}</Form.Item>
                            <Form.Item label="Professor do AEE">
                                {getFieldDecorator("professor_aee", { initialValue: registo.professor_aee })(<Input />)}
                            </Form.Item>
                        </div>
                        <div className="bloco" style={{ marginBottom: 50 }}>
                            <Form.Item label="2. Histórico Escolar e Funcional">
                                {getFieldDecorator("historico_escolas", { initialValue: registo.historico_escolas })(
                                    <TextArea
                                        rows={4}
                                        style={{ height: 100 }}
                                        placeholder="Insira informações sobre o histórico escolar e funcional..."
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label="3. Caracterização e Necessidades Educacionais Específicas">
                                {getFieldDecorator("necessidades_educacionais", {
                                    initialValue: registo.necessidades_educacionais
                                })(
                                    <TextArea
                                        rows={4}
                                        style={{ height: 100 }}
                                        placeholder="Descreva as características e necessidades educacionais específicas..."
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="bloco" style={{ marginBottom: 50 }}>
                            <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                4. Objetivos do AEE
                            </h3>
                            <Form.Item label="Cognitivos">
                                {getFieldDecorator("objetivos_cognitivos", { initialValue: registo.objetivos_cognitivos })(
                                    <TextArea rows={4} style={{ height: 100 }} placeholder="Descreva os objetivos cognitivos..." />
                                )}
                            </Form.Item>
                            <Form.Item label="Socioemocionais e Comportamentais">
                                {getFieldDecorator("objetivos_socioemocionais", {
                                    initialValue: registo.objetivos_socioemocionais
                                })(
                                    <TextArea
                                        rows={4}
                                        style={{ height: 100 }}
                                        placeholder="Descreva os objetivos socioemocionais e comportamentais..."
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="bloco" style={{ marginBottom: 50 }}>
                            <Form.Item label="5. Estratégias Pedagógicas e Recursos">
                                {getFieldDecorator("estrategias_recursos", { initialValue: registo.estrategias_recursos })(
                                    <TextArea
                                        rows={4}
                                        style={{ height: 100 }}
                                        placeholder="Descreva as estratégias pedagógicas e recursos..."
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label="6. Parcerias">
                                {getFieldDecorator("parcerias", { initialValue: registo.parcerias })(
                                    <TextArea rows={4} style={{ height: 100 }} placeholder="Descreva as parcerias..." />
                                )}
                            </Form.Item>
                            <Form.Item label="7. Cronograma de Atendimentos">
                                {getFieldDecorator("cronograma_atendimentos", { initialValue: registo.cronograma_atendimentos })(
                                    <TextArea rows={4} style={{ height: 100 }} placeholder="Descreva o cronograma de atendimentos..." />
                                )}
                            </Form.Item>
                            <Form.Item label="8. Avaliação e Monitoramento">
                                {getFieldDecorator("avaliacao_monitoramento", { initialValue: registo.avaliacao_monitoramento })(
                                    <TextArea
                                        rows={4}
                                        style={{ height: 100 }}
                                        placeholder="Descreva como será feita a avaliação e monitoramento..."
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="ant-drawer-footer">
                            <button
                                className="botao-secundario"
                                type="button"
                                onClick={handleClose}
                                style={{ marginRight: 20, display: "inline-block" }}
                            >
                                Cancelar
                            </button>
                            <button className="botao-principal" disabled={isLoading}>
                                {isLoading ? <Icon type="loading" /> : null}
                                Salvar Planejamento
                            </button>
                        </div>
                    </Form>
                </div>
            </Drawer>
        </>
    );
};

export default Form.create({ name: "form-drawer-adicionar-plano" })(DrawerAdicionarPlano);
